import React from "react";
import PropTypes from "prop-types";
import {
    PageContainer,
    PageContent,
    PageFooter
} from "@zandor300/backoffice-framework";

function BackofficePageContainer({ children }) {
    return (
        <PageContainer>
            <PageContent>
                { children }
            </PageContent>
            <PageFooter>
                SwEngage Backoffice
            </PageFooter>
        </PageContainer>
    );
}
BackofficePageContainer.propTypes = {
    children: PropTypes.object
};

export default React.memo(BackofficePageContainer);
